import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import {
  installEncodedUpdateDeepLinkHashCaptureFix,
  normalizeEncodedUpdateDeepLinkHash,
} from './app/core/utils/legacy-workluge-url.util';

// Capture-phase listener must register before Angular's hashchange handler.
installEncodedUpdateDeepLinkHashCaptureFix();
// Cold load / full refresh of an encoded email deep link.
normalizeEncodedUpdateDeepLinkHash();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
